// Components==============
import Avatar from 'components/UI/Avatar/Avatar';
import Token from 'components/UI/Token/Token';
import { EditableProcessEntity } from 'hooks/useProcessGroups';
import { useTranslate } from 'hooks/useTranslate';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import React, { useContext } from 'react';
import { sortMembers } from 'utilities/sortMembers';
import { ProjectProcessContext } from '../../ProjectProcess';
import Edit from './Edit';
import './StartPoint.module.scss';
// =========================

export default function StartPoint({
  token,
  process,
}: {
  token?: PhaseEntity | ActivityEntity | TrainingEntity;
  process?: EditableProcessEntity;
}) {
  const { isEditable, inModal, processGroups } = useContext(
    ProjectProcessContext
  );

  const { project } = useContext(ProjectDetailsContext);

  const translate = useTranslate();

  const description = processGroups?.find(
    (group) =>
      group.id === process?.id && group.process_type === process.process_type
  )?.description as StartPointType | undefined;

  const sortedMembers = sortMembers(project);

  const members = sortedMembers?.length
    ? [
        ...sortedMembers
          ?.filter(
            (member) =>
              member.member.membership !== 'invited' &&
              member.member.membership !== 'teacher'
          )
          ?.map((member) => member.member.user),
      ]
    : [];

  // TODO: add extern to stakeholders

  return (
    <div styleName="wrapper">
      <div styleName="top" style={{ pointerEvents: inModal ? 'none' : 'all' }}>
        <div styleName="token">
          {token && 'thumbnail' in token && <Token token={token} />}
        </div>
      </div>
      <div styleName="bottom_">
        {isEditable ? (
          <Edit process={process} />
        ) : (
          <div styleName="grid" style={{ gap: '0.75rem' }}>
            <strong>{description?.design_question}</strong>
            <p styleName="description">{description?.content}</p>
            {!!description?.sub_questions?.length && (
              <>
                <ul>
                  {description?.sub_questions?.map((q) => (
                    <li key={q.id}>{q.value}</li>
                  ))}
                </ul>
              </>
            )}
            {!!members?.length && !inModal && (
              <div>
                <div styleName="roles-grid">
                  <h3>Team</h3>
                  <h3>{translate('general.terms.role')}</h3>
                </div>
                <div styleName="sub-grid">
                  {members
                    .filter((m) => m.roles.some((r) => r.name !== 'Extern'))
                    .map((member, i) => {
                      if (!member) return <></>;

                      const role = description?.member_roles?.find(
                        (r) => r.member_id === member.id
                      );

                      return (
                        <div styleName="roles-grid" key={i}>
                          <div styleName="user">
                            <Avatar user={member} />
                            <p>
                              {member.first_name} {member.last_name}
                            </p>
                          </div>
                          <p styleName={!role?.role ? 'no-role' : ''}>
                            {role?.role || 'Held zonder rol'}
                          </p>
                        </div>
                      );
                    })}
                </div>
              </div>
            )}
            {!!description?.stakeholders?.length && (
              <div>
                <div styleName="roles-grid">
                  <h3>Stakeholders & experts</h3>
                  <h3>{translate('general.terms.role')}</h3>
                </div>
                <div styleName="sub-grid">
                  {description.stakeholders.map((stakeholder) => (
                    <div styleName="roles-grid" key={stakeholder.id}>
                      <div styleName="user">
                        <img src={stakeholder.image} alt={stakeholder.name} />
                        <p>{stakeholder.name}</p>
                      </div>
                      <p>{stakeholder.role}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
